import React from "react";
import Helmet from "react-helmet";
import Layout from "../components/layout";
import Vimeo from '@u-wave/react-vimeo';
// import Lightbox from 'react-images'

import Gallery from "../components/Gallery";

import full01 from "../assets/images/fulls/studentsports_elite-11.jpg";
import full02 from "../assets/images/fulls/studentsports_area-code-baseball.jpg";
import full03 from "../assets/images/fulls/studentsports_about.jpg";
import full04 from "../assets/images/fulls/studentsports_home.jpg";


import thumb01 from "../assets/images/fulls/studentsports_elite-11.jpg";
import thumb02 from "../assets/images/fulls/studentsports_area-code-baseball.jpg";
import thumb03 from "../assets/images/fulls/studentsports_about.jpg";
import thumb04 from "../assets/images/fulls/studentsports_home.jpg";




const DEFAULT_IMAGES = [
  {
    id: "1",
    source: full01,
    thumbnail: thumb01,
  },
  {
    id: "2",
    source: full02,
    thumbnail: thumb02,
  },
  {
    id: "3",
    source: full03,
    thumbnail: thumb03,
  },
  {
    id: "4",
    source: full04,
    thumbnail: thumb04,
  },
];

const SportsConnect = () => (
  <Layout>
           <Helmet>
          <title>Andy Miller - Student Sports</title>
        </Helmet>
        <div id="main">
    <h1>Student Sports</h1>
    <p>I designed and developed the website for Student Sports, a creative agency focused on solutions in all things sport. Student Sports needed a website where they could showcase their case studies in a one-pager fashion. Student sports also had a deep repository of great images and videos which made my job easy. The videos and images became the star of the show, with the homepage being a stinger video of the best clips. The case study pages also benefited, with each case study rich in images. This was another site built in Wordpress, where I develop the site to be taken over by someone not as technically inclined. Overall this site was executed easily and to everyones satisfaction with the help of the content provided to me.</p>
    
    <a href="https://studentsports.com" class="button marginb">
      Live Website
    </a>

    <Gallery
              images={DEFAULT_IMAGES.map(
                ({ id, source, thumbnail, caption, description }) => ({
                  source,
                  thumbnail,
                })
              )}
            />
    </div>
  </Layout>
);

export default SportsConnect;
